module.exports = __webpack_public_path__ + "img/pgs-logo.ebfe9e82.jpg";